import { matchPath, Outlet, useNavigation } from 'react-router-dom';

import { CircularProgress } from '@packages/fenrir/components/progress';
import { Stack } from '@packages/fenrir/components/stack';
import { env } from '@packages/utils/env';

export const LoadingOutlet = ({
  isLoadingAccessData,
}: {
  isLoadingAccessData: boolean;
}) => {
  const navigation = useNavigation();

  if (env.MODE === 'e2e') {
    // avoid rendering homepage for e2e testing
    // TODO: look at POM/helpers for the e2e test cases to avoid them landing on
    // dashboard by default or add correct fixture so page loads correctly
    if (matchPath('/:organizationId', window.location.pathname))
      return 'Home page';
  }

  const isLoading = navigation.state === 'loading';

  return isLoading || isLoadingAccessData ? (
    <Stack
      sx={{
        cursor: 'progress',
        flex: 1,
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <CircularProgress />
    </Stack>
  ) : (
    <Outlet />
  );
};
